import React, { useState } from "react";
import { Button, Row, Col, Form, message } from "antd";
import dayjs from "dayjs";
import { DateField, InputField } from "../../../../atoms/FormElement";
import { useForm } from "react-hook-form";
import { addHolidays, getHolidays } from "../../ducks/actions";
import LoaderIcon from "../../../../atoms/Icons/LoaderIcon";
import { useDispatch } from "react-redux";

const HolidayForm = ({ providerData }) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm();
    const [load, setLoader] = useState(false);

    const dispatch: any = useDispatch();



    const updateDates = () => {

        const startOfMonth = dayjs().startOf('month');
        const endOfMonth = dayjs().endOf('month');
        const dateRange = {
            fromDate: startOfMonth.format('YYYY-MM-DD'),
            toDate: endOfMonth.format('YYYY-MM-DD'),
        }

        const payload = {
            provider: providerData,
            range: [dateRange?.fromDate, dateRange?.toDate]
        }
        if (payload && providerData) {
            setTimeout(() => {
                dispatch(getHolidays(payload));
            }, 800);
        }
    }

    const onSubmit = async (values) => {
        if (!(values.holidays?.length > 0) || !providerData) { message.error("Failed to add"); return; }
        const payload = {
            provider: providerData,
            dates: values.holidays.map(e => dayjs(e).format("YYYY-MM-DD")),
            remarks: values.remarks
        };
        try {
            setLoader(true);
            await addHolidays(payload);
            message.success("Holidays added successfully");
            updateDates();
            reset();
            setLoader(false);
        } catch (error) {
            setLoader(false);
            message.error("Failed to add holiday");
        }
    };

    return (
        <div style={{ height: '100%' }}>
            <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
                <Row gutter={16}>
                    <Col span={8}>
                        <InputField
                            label="Remarks"
                            fieldname="remarks"
                            iProps={{ placeholder: "Enter Remarks", }}
                            initValue=""
                            disabled={!providerData || load}
                            isRequired={true}
                            control={control}
                            rules={{ required: "Remarks Required" }}
                            validate={errors.remarks && "error"}
                            validMessage={errors.remarks && errors.remarks.message}
                        />
                    </Col>
                </Row>
                <DateField
                    isRequired={true}
                    fieldname="holidays"
                    label="Select Holiday Dates"
                    control={control}
                    rules={{
                        required: "Please select date(s)",
                    }}
                    iProps={{
                        format: "DD-MM-YYYY",
                        placeholder: "DD-MM-YYYY",
                        multiple: true,
                        disabled: !providerData || load,
                    }}
                    validate={errors.holidays && "error"}
                    validMessage={errors.holidays && errors.holidays.message}
                />
                <div style={{ marginTop: 16, display: "flex" }}>
                    {!load ? (
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={!providerData}
                        >
                            Submit
                        </Button>
                    ) : (<><LoaderIcon />&nbsp; Saving</>)}

                </div>
            </Form>
        </div>
    );
};

export default HolidayForm;
